import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row q-col-gutter-y-md text-center" }
const _hoisted_2 = { class: "col-12 col-sm-6" }
const _hoisted_3 = { class: "text-h5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-body1 text-uppercase" }, "Images", -1)
const _hoisted_5 = { class: "col-12 col-sm-6" }
const _hoisted_6 = { class: "text-h5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-body1 text-uppercase" }, "Videos", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_image_count = _resolveComponent("image-count")!
  const _component_video_count = _resolveComponent("video-count")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_image_count, {
          filters: { accountIds: [this.accountId]}
        }, null, 8, ["filters"])
      ]),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_video_count, {
          filters: { accountIds: [this.accountId]}
        }, null, 8, ["filters"])
      ]),
      _hoisted_7
    ])
  ]))
}